"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SentryError = void 0;

var _tslib = require("tslib");

var _polyfill = require("./polyfill");

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = function (_super) {
  (0, _tslib.__extends)(SentryError, _super);

  function SentryError(message) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message) || this;

    _this.message = message;
    _this.name = _newTarget.prototype.constructor.name;
    (0, _polyfill.setPrototypeOf)(_this, _newTarget.prototype);
    return _this;
  }

  return SentryError;
}(Error);

exports.SentryError = SentryError;